import api from 'api';

export const loadConversionPagesGrid = api('POST /api/conversion-pages/grid');

export const loadConversionPage = api('GET /api/conversion-pages/:id');

export const loadConversionPageDetails = api(
  'GET /api/conversion-pages/:id/details'
);

export const updateConversionPage = api('PUT /api/conversion-pages/:id');

export const exportConversionPages = api('POST /api/conversion-pages/export', {
  responseType: 'blob',
});
